module.exports = __webpack_public_path__ + "static/media/tndr-busd.a40c1285.png";